import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS, ValidatorFn, UntypedFormControl } from '@angular/forms';

@Directive({
    selector: '[NoWhitespaceValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NoWhitespaceValidatorDirective,
            multi: true
        }
    ]
})
export class NoWhitespaceValidatorDirective implements Validator {

    validator: ValidatorFn;

    constructor() {
        this.validator = this.noWhitespaceValidator();
    }

    validate(c: UntypedFormControl) {
        return this.validator(c);
    }

    noWhitespaceValidator(): ValidatorFn {
        return (control: UntypedFormControl) => {
            if (!control.value) {
                return {
                    noWhitespaceValidator: { valid: false }
                };
            }

            const value = control.value.replace(/ /g, '');
            if (!value) {
                return {
                    noWhitespaceValidator: { valid: false }
                };
            }

            return null;
        };
    }
}